<template>
  <div>
    <!-- <TopNavbar /> -->
    <!-- {{Lang.get('messages.Forms.add_new_code')}} -->
    <!-- @lang('messages.welcome') -->

    <!-- <section
            class="md:flex bg-cover bg-no-repeat bg-center bg-cover bg-grey h-screen-2/5 mb-48"
        >
            
        </section> --> 
    

    <HomeSlider></HomeSlider>

    <SearchPackage></SearchPackage>
  </div>
</template>

<script>
import AlbumsMix from "./mixins/albums/GetAlbumsByEmail";
import SearchPackage from "./photo/searchPackageComponent";
import HomeSlider from "./sliders/HomeSlider.vue";


export default {
    props: [],
    mixins: [AlbumsMix],
    components: {
        HomeSlider,
        SearchPackage
    },
    computed: {},
    async created() {},
    async mounted() {
      // await this.getAlbumsByEmail();
    }
};
</script>

<style></style>
